<div
  *ngIf="parentForm"
  [formGroup]="parentForm"
  class="purchase-order-shipment-extra-cost-table"
>
  <div formArrayName="shipmentExtraCosts" class="purchase-order-shipments-table">
    <table
      *ngIf="extraCostsFormArray.controls?.length; else empty"
      class="lum-table lum-table--classic striped"
    >
      <thead>
        <tr>
          <th>Reference #</th>
          <th>Item</th>
          <th>Cost Allocation</th>
          <th>Category</th>
          <th>Qty</th>
          <th>Unit Price</th>
          <th>Line Total</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container
          *ngFor="
            let extraCost of extraCostsFormArray.controls;
            let i = index;
            trackBy: trackByControlValue
          "
        >
          <tr [formGroupName]="i">
            <td>
              <span>{{ extraCost.get('referenceNumber')?.value }}</span>
            </td>
            <td>
              <input
                formControlName="name"
                type="text"
                class="lum-input"
                required
                [ngClass]="{
                  error: extraCost.get('name')?.invalid,
                }"
              />
            </td>
            <td>
              <mat-select
                class="lum-select"
                formControlName="costAllocationType"
                required
              >
                <mat-option
                  *ngFor="
                    let allocation of COST_ALLOCATION_TYPES;
                    trackBy: trackByValue
                  "
                  [value]="allocation.value"
                >
                  {{
                    allocation.label
                      | stringTransformation
                        : stringTransformationType.SNAKE_TO_TITLE_CASE
                  }}
                </mat-option>
              </mat-select>
            </td>
            <td>
              <lum-ui-autocomplete-chip
                [debounceTime]="500"
                [options]="itemProductCategories"
                [displayProperty]="'name'"
                [formArray]="
                  parentForm.get(['shipmentExtraCosts', i])?.get('categories')
                "
                [selectedOptions]="
                  parentForm.get(['shipmentExtraCosts', i])?.get('categories')
                    ?.value || []
                "
              ></lum-ui-autocomplete-chip>
            </td>

            <td>
              <input
                formControlName="quantity"
                type="number"
                class="lum-input text-right"
                lumDecimalLimit
              />
            </td>
            <td>
              <input
                formControlName="unitPrice"
                type="number"
                class="lum-input text-right"
              />
            </td>
            <td class="text-right">
              <b>{{
                extraCost.get('quantity').value * extraCost.get('unitPrice').value
                  | lumCurrency
              }}</b>
            </td>
            <td *ngIf="mode !== 'view'">
              <button
                (click)="onRemoveExtraCostItem(i)"
                mat-icon-button
                color="warn"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>

        <tr>
          <td class="text-right"><b>Total</b></td>
          <td class="text-right">
            <b>{{ totalExtraCostQuantity | decimalPlaces }}</b>
          </td>
          <td class="text-right" colspan="3">
            <b>{{ totalExtraCostUnitPrice | lumCurrency }}</b>
          </td>
          <td class="text-right">
            <b>{{ totalExtraCostLineTotal | lumCurrency }}</b>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <button
      *ngIf="mode !== 'view'"
      class="lum-button lum-button--secondary w-100 mt-4"
      [matMenuTriggerFor]="menuExtraCosts"
    >
      Add Item(s)
    </button>
    <mat-menu
      class="lum-mat-menu"
      #menuExtraCosts="matMenu"
      yPosition="above"
      xPosition="before"
    >
      <button (click)="onAddExtraCostItem(1)" mat-menu-item>Add 1 Item</button>
      <button (click)="onAddExtraCostItem(5)" mat-menu-item>Add 5 Items</button>
      <button (click)="onAddExtraCostItem(10)" mat-menu-item> Add 10 Items </button>
      <button (click)="onAddExtraCostItem(25)" mat-menu-item> Add 25 Items </button>
      <button (click)="onAddExtraCostItem(50)" mat-menu-item> Add 50 Items </button>
    </mat-menu>
  </div>
</div>

<ng-template #empty>
  <lum-ui-empty-page
    class="mt-8"
    title="There are no extra costs to display"
  ></lum-ui-empty-page>
</ng-template>
